import { X } from "lucide-react";
import { useEffect, useState } from "react";

import { ClassicLink } from "@/common/components";

const LS_KEY = "isReadUseLC";

export function LocalStoragePolicyBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const alreadyRead = localStorage.getItem(LS_KEY) === "true";
    if (!alreadyRead) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(LS_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg"
      role="dialog"
      aria-label="Уведомление об использовании local storage"
    >
      <div className="max-w-screen-xl mx-auto px-4 py-4 flex items-start gap-4">
        <p className="flex-1 text-sm text-gray-700 leading-5">
          ЭИС использует файлы «Local Storage» в соответствии с{" "}
          <ClassicLink href="/privacy_policy.pdf">
            Политикой в отношении обработки персональных данных
          </ClassicLink>{" "}
          с целью персонализации сервисов и повышения удобства пользования веб-сайтом. «Local
          Storage» представляют собой небольшие файлы, содержащие информацию о предыдущих посещениях
          веб-сайта. Посещая сайт, вы соглашаетесь с обработкой «Local Storage». Если вы не хотите
          использовать файлы «Local Storage» — измените настройки браузера.
        </p>
        <button
          onClick={handleClose}
          className="flex-shrink-0 p-1 rounded-md text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
          aria-label="Закрыть"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
